export default __webpack_public_path__ + "static/media/saved.1fe1b83f.svg";